<template>
    <div>
        <register-phone v-if="page == 'register-phone' && isInternetConnected"
                         @onPageChange="changePage($event)"
                         @onRequestedOtp="onRequestedOtp"></register-phone>
        <register-otp v-if="page == 'register-otp' && isInternetConnected"
                      :registerData="registerData"
                      @onChangePage="changePage($event)"
                      @checkedOtp="onOtpPass($event)"
        ></register-otp>
        <register-form v-if="page == 'register-form' && isInternetConnected"
                       :registerData="registerData"
        ></register-form>

        <register-success :busModal="busModalRegisterSuccess"></register-success>
        <modal view="register-main" :busModal="busModal"></modal>
        <!-- <not-connect
        v-if="!isInternetConnected"
        ></not-connect> -->

    </div>
</template>
<script>
import Vue from "vue";
import Account from "@/helper/AccountHelper.js";
import Util from "@/helper/Utility.js";
import RegisterPhone from "@/views/Register/RegisterPhone.vue";
import RegisterOtp from "@/views/Register/RegisterOtp.vue";
import RegisterForm from "@/views/Register/RegisterForm.vue";
import RegisterSuccess from "@/components/modal/RegisterSuccess.vue";
import Modal from "@/components/modal/Modal.vue";
// import NotConnect from "@/components/NotConnect.vue"
import Locale from "@/helper/locale/locale.js";
import DiorApi from "@/service/dior/DiorApi.js";
import { DiorPorfileModel } from "@/model/Dior/DiorProfileModel.js"
import LineFunction from '@/helper/facade/LineFunction.js';
import { TrackingService } from "@/helper/TrackingHelper";

export default {
    name: "Register",
    components: {
        RegisterPhone,
        RegisterOtp,
        RegisterSuccess,
        RegisterForm,
        Modal,
        // NotConnect,
    },
    data: function() {
        return {
            page: 'register-phone',// register-phone, register-otp, register-form

            registerData: {
                // day: '',
                // month: '',\
                // contactNumber: '',
                // refcode: '',
            },
            isMemberCheck: null,
            isFlowQr: false,
            qrValue: {
                customerId: '',
                counterId: '',
                phone: '',
            },
            lbl: Locale.getLbl(),
            busModalRegisterSuccess: new Vue(),
            busModal: new Vue(),
            isInternetConnected: true,
            errorMessage: '',
            tracking: new TrackingService(this)
        };
    },
    created: function() {


        this.flowQrScan();

        if (!this.isFlowQr) {
            this.page = 'register-phone';
        }

        // this.page = 'register-form';

        //! debug code (remove this)
        // this.page = 'register-form';
        // this.registerData.contactNumber = "0811231234";

        this.tracking.screenName('register');
    },
    mounted: function() {
        this.checkIsAlreadyRegister((result) => {
            if (result) {
                //go profile
                // this.$router.push('/profile');
            } else {
                this.flowQrScan();
            }
        });
    },
    methods: {
        changePage: function(data) {
            console.log(data);
            this.page = data.page;
        },
        onRequestedOtp: function(data) {
            this.registerData = data;
            this.page = 'register-otp';
        },
        initLiff: function() {
            return new Promise((resolve) => {
                var lineFunction = new LineFunction();
                this.liffId = lineFunction.getLiffId();

                lineFunction.init(this.liffId).then(() => {

                    this.lineIdToken = lineFunction.getIdToken();
                    resolve();
                }).catch((err) => {
                    console.log(err);
                    this.setNotLineRegister();
                    // this.$router.replace('/error');
                });
            });

        },
        onOtpPass: async function(data) {

            await this.initLiff();
            if (this.isFlowQr) {

                this.registerData.day = Account.getCacheCustom("DiorQrBday");
                this.registerData.month = Account.getCacheCustom("DiorQrBmth");
                this.sendRegisterMemberQr(this.registerData.day, this.registerData.month, data);
                return;
            }
            var token = Account.getToken();
            var birthdate = this.registerData.day + '/' + this.registerData.month;
            // var lineUserId = Account.getLineUserId();
            DiorApi.checkIsMember(token, this.registerData.contactNumber, birthdate, this.lineIdToken).then((res) => {

                this.isMemberCheck = res.data;
                if (res.data.IsMember) {
                    // * go success/profile
                    console.log('is Member');
                    var diorProfile = new DiorPorfileModel();
                    diorProfile.setDataFormApi(res.data);
                    Account.setCacheDiorProfile(diorProfile);
                    window.location.replace("/landing/line?target_page=profile");
                    // this.$router.push('/profile');
                } else {
                    console.log('open register form');
                    this.page = 'register-form';
                }
            }).catch((err) => {
                if (err.response) {
                    console.log(err.response.data);

                }
                else {
                    this.showErrorConnectModal();
                    console.log(err);
                }
            });
        },

        //#region flow qr scan
        flowQrScan: function() {
            this.isFlowQr = false;
            var isQrFlow = this.$route.query.qr;
            if (isQrFlow == true || isQrFlow == 'true') {
                var customerId = Vue.$cookies.get('DiorQrCustomerId');
                var counterCode = Vue.$cookies.get('DiorQrCounterCode');
                var phone = Vue.$cookies.get('DiorQrPhone');

                if (!Util.isEmptyStr(customerId) && !Util.isEmptyStr(counterCode) && !Util.isEmptyStr(phone)) {
                    this.startFlowQr(phone);
                    this.qrValue.customerId = customerId;
                    this.qrValue.counterId = counterCode;
                    this.qrValue.phone = phone;
                    this.isFlowQr = true;

                    return true;
                }
            }

            return false;
        },

        startFlowQr: function(phone) {
            this.registerData.contactNumber = phone;
            this.page = 'register-otp';
        },

        sendRegisterMemberQr: function(day, month, dataOtp) {
            // console.log('send register qr');
            day = day.length == 1 ? '0' + day : day;
            month = month.length == 1 ? '0' + month : month;

            var token = Account.getToken();
            DiorApi.registerQr(token, this.qrValue.customerId, this.qrValue.counterId, this.qrValue.phone, day, month, dataOtp)
                .then((res) => {
                    console.log(res.data);
                    this.$router.push('/profile');
                })
                .catch((err) => {
                    if (err.response) {
                        console.log(err.response.data);
                        var error = err.response.data.error;
                        // if (error.id == 2091) {

                        //     this.errorMessage = this.lbl.register.otp.notcorrect;

                        // } else if (error.id == 2092) {

                        //     this.errorMessage = this.lbl.register.otp.otpexpire;

                        // }
                        // else {
                        //     this.errorMessage = error.message;
                        // }
                        this.showErrorConnectModal(error.message);

                    } else {

                        console.log(err);
                        this.showErrorConnectModal();
                    }
                });
        },
        //#endregion flow qr scan

        //#region flow old user
        checkIsAlreadyRegister: async function(callback) {
            var token = Account.getToken();
            // var lineUserId = Account.getLineUserId();
            this.showLoading();
            await this.initLiff();
            DiorApi.isUserRegistered(token, this.lineIdToken).then((res) => {
                this.hideLoading();
                console.log(res.data);
                var isMember = (res.data) ? res.data.IsMember : false;
                if (typeof callback == 'function') {
                    callback(isMember);
                }
            }).catch((err) => {
                this.hideLoading();
                if (err.response) {
                    console.log(err.response.data);
                } else {
                    console.log(err);
                    this.showErrorConnectModal();
                    // this.isInternetConnected = false;
                }

                if (typeof callback == 'function') {
                    callback(false);
                }
            });
        },
        //#endregion flow old user

        showErrorConnectModal: function(data) {
            var configModal = {
                 message: "",
                 strBtnOk: ""
            }
            if (data) {
                configModal.message = data;
                configModal.strBtnOk = this.lbl.error_connect.btn_close;

            } else {

                configModal.message = this.lbl.error_connect.message;
                configModal.strBtnOk = this.lbl.error_connect.btn_close;
            }


            this.busModal.$emit('showErrorConnectModal', configModal);
        },

        //#region modal
        showLoading: function() {
            this.busModal.$emit('showLoadingModal');
        },
        hideLoading: function() {
            this.busModal.$emit('hideLoadingModal');
        },
        //#endregion modal
    },
}
</script>
<style lang="scss" scoped>

</style>
